import {takeEvery} from 'redux-saga/effects'
import {
  ADD_TERM,
  DELETE_MANY_TERMS,
  DELETE_SINGLE_TERM,
  GET_TERMS,
  GET_TERM_SINGLE,
  LOCK_UNLOCK_TERMS,
  UPDATE_TERM,
} from 'setup/redux/Actions/Term/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_TERMS, fetchData)
  yield takeEvery(GET_TERM_SINGLE, fetchData)
  yield takeEvery(ADD_TERM, fetchData)
  yield takeEvery(UPDATE_TERM, fetchData)
  yield takeEvery(DELETE_SINGLE_TERM, fetchData)
  yield takeEvery(DELETE_MANY_TERMS, fetchData)
  yield takeEvery(LOCK_UNLOCK_TERMS, fetchData)
}

export default dataSaga
